import React from 'react';
import Profile from 'pages/profile/containers/Profile';

function Index(props: any) {
    return (
        <Profile />
    );
}

export default Index;